import React from 'react';
import { Stack, Button } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const BackToDashboard = () => {

  const handleBack = () => {
    window.history.back();
  };

  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={1}
      sx={{ mb: 2, color: 'primary.main' }}
    >
      <Button
        onClick={handleBack}
        variant="text"
        color="primary"
        startIcon={<ArrowBackIcon />}
        sx={{
          textTransform: "none",
          fontWeight: 500,
          borderRadius: 50,
          px: 1.5,
          py: 0.5,
        }}
      >
        Back to Dashboard
      </Button>
    </Stack>
  );
};

export default BackToDashboard;
